import { paths } from 'config'
import { useTranslation } from 'react-i18next'
import { useHistory, useLocation } from 'react-router-dom'
import PersistentSnackbar from 'shared/components/PersistentSnackbar'
import { useTwoFactorPromptState } from './TwoFactorPromptContext'

const TwoFactorPromptSnackbar = () => {
  const { t } = useTranslation()
  const history = useHistory()
  const location = useLocation()
  const { visible, hideTwoFactorPrompt } = useTwoFactorPromptState()

  return (
    <PersistentSnackbar
      stacked
      severity="warning"
      variant="filled"
      open={visible && location.pathname !== paths.security}
      message={t('twoFactorPrompt.message')}
      actionLabel={t('twoFactorPrompt.enable')}
      onAction={() => history.push(paths.security)}
      actionButtonProps={{
        size: 'small',
        color: 'inherit',
      }}
      onClose={hideTwoFactorPrompt}
    />
  )
}

export default TwoFactorPromptSnackbar
